import React from "react";

const PopupDetails = ({ layer, onClose }) => {
  // layer가 없을 경우 null 반환
  if (!layer) return null;

  const popupStyle = {
    position: "fixed",
    top: "50%", // 화면 중앙
    left: "50%", // 화면 중앙
    transform: "translate(-50%, -50%)", // 중앙 정렬
    backgroundColor: "white",
    border: "1px solid #ccc",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
    width: "350px",
    zIndex: 1000,
    textAlign: "center",
  };

  const closeButtonStyle = {
    marginTop: "15px",
    padding: "10px 20px",
    backgroundColor: "#e63946", // 밝은 빨간색
    color: "white",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  };

  const closeButtonHoverStyle = {
    backgroundColor: "#c92a2a", // 더 진한 빨간색
  };

  const protocols = layer.protocols || []; // protocols가 없을 경우 빈 배열로 처리

  return (
    <div style={popupStyle}>
      <h2 style={{ color: "#007bff", marginBottom: "10px" }}>{layer.name}</h2>
      <p style={{ whiteSpace: "pre-line", fontSize: "14px", color: "#333" }}>
        {layer.description}
      </p>
      <strong style={{ display: "block", margin: "10px 0" }}>Protocols:</strong>
      <ul style={{ listStyleType: "none", padding: 0 }}>
        {protocols.map((protocol) => (
          <li
            key={protocol}
            style={{
              padding: "5px",
              backgroundColor: "#f1f3f5",
              borderRadius: "5px",
              margin: "3px 0",
              fontSize: "14px",
            }}
          >
            {protocol}
          </li>
        ))}
      </ul>
      <button
        onClick={onClose}
        style={closeButtonStyle}
        onMouseOver={(e) => (e.target.style.backgroundColor = closeButtonHoverStyle.backgroundColor)}
        onMouseOut={(e) => (e.target.style.backgroundColor = closeButtonStyle.backgroundColor)}
      >
        닫기
      </button>
    </div>
  );
};

export default PopupDetails;
